<template>
  <v-card flat class="outline">
    <v-card-title v-if="translatedLabel">
      <span class="subtitle-1">{{ translatedLabel }}</span>
    </v-card-title>
    <v-card-text v-if="translatedDescription" :class="descriptionClass">{{ translatedDescription }}</v-card-text>
  </v-card>
</template>

<script>
import translationMixin from './checklist-translation-mixin.es6'

export default {
  name: 'checklist-info',
  props: {
    level: Number,
    index: Number,
    label: String,
    description: String
  },
  mixins: [translationMixin],
  computed: {
    descriptionClass () {
      return {
        'pt-0': !!this.translatedLabel,
        'grey--text': true,
        'text--darken-2': true
      }
    }
  }
}
</script>
